import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';

export default function CoreResultSetSummary({ model, onRetry }) {
  if (!model) return null;

  return (
    <Box data-testid="core-result-set-summary" sx={{ minWidth: 0 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, overflowWrap: 'anywhere' }}>
        {model.heading}
      </Typography>
      {model.totalLabel && (
        <Typography variant="body2" color="text.secondary">
          {model.totalLabel}
        </Typography>
      )}

      {model.status === 'loading' ? (
        <Box display="flex" alignItems="center" gap={1} sx={{ mt: 0.75 }}>
          <CircularProgress size={16} aria-hidden="true" />
          <Typography variant="body2" color="text.secondary">
            {model.statusMessage}
          </Typography>
        </Box>
      ) : (
        <>
          {model.statusMessage && (
            <Alert
              severity={model.status === 'failed' || model.status === 'forbidden' ? 'error' : 'info'}
              sx={{ mt: 1, py: 0.5, minWidth: 0, '& .MuiAlert-message': { overflowWrap: 'anywhere' } }}
            >
              {model.statusMessage}
            </Alert>
          )}

          {model.providerPartialMessage && (
            <Alert
              severity="warning"
              sx={{ mt: 1, py: 0.5, minWidth: 0, '& .MuiAlert-message': { overflowWrap: 'anywhere' } }}
            >
              {model.providerPartialMessage}
            </Alert>
          )}

          {model.recoveryGuidance && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {model.recoveryGuidance}
            </Typography>
          )}

          {model.retryable && typeof onRetry === 'function' && (
            <Button size="small" variant="outlined" onClick={onRetry} sx={{ mt: 1 }}>
              Retry Core result set
            </Button>
          )}
        </>
      )}
    </Box>
  );
}
